import { MutableRefObject } from 'react';
export const debounceHandler = (
  callback: () => void,
  timmerRef: MutableRefObject<ReturnType<typeof setTimeout> | undefined>,
  delay: number
) => {
  clearTimeout(timmerRef.current);
  timmerRef.current = setTimeout(callback, delay);
};
